import { Action, Transaction } from '@near-wallet-selector/core';
import JSBI from 'jsbi';
import { Account } from 'near-api-js';
import { DEFAULT_GAS, WRAPPED_NEAR_ID } from '../../../constants';
import { registerToken } from '../../registerToken';

export const builDepositNearActions = async (
  account: Account,
  amount: JSBI
) => {
  const actions = new Array<Action>();

  const registerTokenTx = await registerToken(
    account.connection.provider,
    WRAPPED_NEAR_ID,
    account.accountId
  );

  let deposit = amount;

  if (registerTokenTx) {
    actions.push(...registerTokenTx.actions);
  } else {
    const balance = await account.viewFunction(
      WRAPPED_NEAR_ID,
      'ft_balance_of',
      { account_id: account.accountId }
    );

    if (JSBI.greaterThanOrEqual(JSBI.BigInt(balance), deposit)) {
      return [];
    }

    console.log('NEAR account found, balance:', balance);
    deposit = JSBI.subtract(amount, JSBI.BigInt(balance));
  }

  actions.push({
    type: 'FunctionCall',
    params: {
      methodName: 'near_deposit',
      args: {},
      gas: DEFAULT_GAS,
      deposit: deposit.toString(),
    },
  });

  return actions;
};

export const buildDepositNearTransaction = async (
  account: Account,
  amount: JSBI
) => {
  const transaction: Transaction = {
    receiverId: WRAPPED_NEAR_ID,
    signerId: account.accountId,
    actions: await builDepositNearActions(account, amount),
  };

  return transaction;
};
